import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'

import { getEditInboundOriginAddressPayload } from './helpers'

const useParcelInboundOriginAddress = ({ storeId, parcelId, onParcelEdited, setToastInfo, parcel }) => {
  const { fetchData, loading } = useFetch(parcelServices.editParcel, { doInitialRequest: false })
  const [showEditInboundOriginAddressModal, setShowEditInboundOriginAddressModal] = useState(false)

  const openEditInboundOriginAddressModal = () => {
    setShowEditInboundOriginAddressModal(true)
  }

  const closeEditInboundOriginAddressModal = () => {
    setShowEditInboundOriginAddressModal(false)
  }

  const onEditInboundOriginAddress = async address => {
    const payload = getEditInboundOriginAddressPayload(address)

    try {
      const updatedShipment = await fetchData({ storeId, parcelId, payload })
      closeEditInboundOriginAddressModal()
      onParcelEdited(updatedShipment)
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  const allowEditInboundOriginAddress = [
    shipmentStatuses.requested,
    shipmentStatuses.packed,
    shipmentStatuses.ready,
  ].includes(parcel?.status)

  return {
    showEditInboundOriginAddressModal,
    openEditInboundOriginAddressModal,
    closeEditInboundOriginAddressModal,
    onEditInboundOriginAddress,
    loading,
    allowEditInboundOriginAddress,
  }
}

export default useParcelInboundOriginAddress
